/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { ReactComponent as ContactIcon } from "cms/assets/icons/phone-volume.svg";
import { ReactComponent as MenuIcon } from "cms/assets/icons/bars.svg";
import { ReactComponent as CloseIcon } from "cms/assets/icons/x.svg";
import { MobileDropdownMenu } from "components/header/header-nav-bar/mobile-menu/mobile-dropdown-menu";

const MobileMenu = () => {

    const [showDropdown, setShowDropdown] = useState(false);

    const toggleMobileDropdown = () => {
        setShowDropdown((prev) => !prev);
    };

    return (
        <div className="langley-mobile-menu">
            <a className='mobile-menu-btn' href='/connect/contact-us'>
                <ContactIcon />
            </a>
            <button className='mobile-menu-btn' onClick={toggleMobileDropdown}>
                {showDropdown && <CloseIcon className='close-icon'/>}
                {!showDropdown && <MenuIcon />}
            </button>
            <MobileDropdownMenu show={showDropdown} />
        </div>
    );
};

export { MobileMenu };
